export default function() {
  return {
    responseAuth: []
  }
}
